import OneTimeACHPaymentPage from "components/pages/OneTimeACHPaymentPage";

export default function CaptureTransactionType(props) {
    return <OneTimeACHPaymentPage />;
}